import '../../scss/blocks/tallow_calculator.scss';

import '../../templates/blocks/tallow_calculator.twig';

import {scrollTo} from "../components/_scroll_to";
import {request} from "../components/_request";

class TallowCalculator {

    constructor(wrapper) {
        this.wrapper = wrapper;
        this.button = wrapper.querySelector('button');
        this.numberFields = wrapper.querySelectorAll('input[type="number"]');
        this.fryers = wrapper.querySelector('#how-many-fryers-do-you-have');
        this.freq = wrapper.querySelector('#how-often-do-you-change-your-fryer-oil');
        this.oilPrice = wrapper.querySelector('#what-price-do-you-pay-per-pound-of-oil');
        this.tallowPrice = wrapper.querySelector('#what-price-do-you-pay-per-pound-of-beef-tallow');
        this.best = wrapper.querySelector('[id="do-you-have-a-best-practices-program-in-place-yes"]');
        this.name = wrapper.querySelector('#tallow-calculator-name');
        this.email = wrapper.querySelector('#tallow-calculator-email');
        this.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.error = wrapper.querySelector('.tallow-calculator__form__error');
        this.recaptcha = JSON.parse(wrapper.dataset.recaptcha || '{}');
        this.recaptchaLoader = null;
        this.results = wrapper.querySelector('.tallow-calculator__form__results');
        this.costResultMonth = wrapper.querySelector('[data-id="cost_savings"] span:nth-child(1)');
        this.costResultYear = wrapper.querySelector('[data-id="cost_savings"] span:nth-child(2)');
        this.amountResultMonth = wrapper.querySelector('[data-id="amount_saved"] span:nth-child(1)');
        this.amountResultYear = wrapper.querySelector('[data-id="amount_saved"] span:nth-child(2)');
    }

    init() {
        this.button.addEventListener('click', this.calculate.bind(this));
        [...this.numberFields, this.name, this.email].forEach((field) => {
            field.addEventListener('input', () => {
                field.classList.remove('error');
                this.hideError();
            });
        });
        this.wrapper.addEventListener('focusin', this.loadRecaptcha.bind(this), {once: true});
    }

    validate() {
        let errorFields = [];
        this.numberFields.forEach((field) => {
            if (field.id === 'what-price-do-you-pay-per-pound-of-beef-tallow')
                return;
            if (field.value === '') {
                field.classList.add('error');
                errorFields.push(field);
                return false;
            }
            field.classList.remove('error');
        });
        if (this.name.value.trim() === '') {
            this.name.classList.add('error');
            errorFields.push(this.name);
        } else {
            this.name.classList.remove('error');
        }
        if (!this.emailPattern.test(this.email.value.trim())) {
            this.email.classList.add('error');
            errorFields.push(this.email);
        } else {
            this.email.classList.remove('error');
        }
        if (errorFields.length > 0) {
            scrollTo(errorFields[0]);
            return false;
        }
        return true;
    }

    /**
     * Load reCAPTCHA api by demand, it is not needed until the form is used.
     * Resolves with null when there is no key or the api is not available,
     * the submit is checked on the server side anyway.
     *
     * @returns {Promise<object|null>}
     */
    loadRecaptcha() {
        if (this.recaptchaLoader) {
            return this.recaptchaLoader;
        }
        this.recaptchaLoader = new Promise((resolve) => {
            if (!this.recaptcha.key) {
                resolve(null);
                return;
            }
            if (window.grecaptcha && window.grecaptcha.execute) {
                resolve(window.grecaptcha);
                return;
            }
            let script = document.createElement('script');
            script.src = this.recaptcha.api;
            script.async = true;
            script.onload = () => resolve(window.grecaptcha || null);
            script.onerror = () => resolve(null);
            document.head.appendChild(script);
        });
        return this.recaptchaLoader;
    }

    /**
     * Get one time token for the current submit.
     *
     * @returns {Promise<string>}
     */
    getToken() {
        return this.loadRecaptcha()
            .then((grecaptcha) => new Promise((resolve) => {
                if (!grecaptcha || !grecaptcha.ready) {
                    resolve('');
                    return;
                }
                grecaptcha.ready(() => {
                    grecaptcha
                        .execute(this.recaptcha.key, {action: this.recaptcha.action})
                        .then((token) => resolve(token))
                        .catch(() => resolve(''));
                });
            }))
            .catch(() => '');
    }

    showError(message) {
        this.error.innerHTML = message || this.error.dataset.default;
        this.error.classList.add('opened');
        scrollTo(this.error);
    }

    hideError() {
        this.error.classList.remove('opened');
    }

    calculate() {
        if (!this.validate()) {
            return false;
        }
        this.hideError();
        this.results.classList.remove('opened');
        this.wrapper.classList.add('loading');
        this.getToken().then((token) => this.send(token));
    }

    send(token) {
        let data = {
            'action': 'get_calculator_data',
            'fryers': this.fryers.value,
            'freq': this.freq.value,
            'oilPrice': this.oilPrice.value,
            'tallowPrice': this.tallowPrice.value,
            'best': this.best.checked ? 'y' : 'n',
            'name': this.name.value.trim(),
            'email': this.email.value.trim(),
            'token': token
        }
        request((response) => {
            let result = {};
            try {
                result = JSON.parse(response);
            } catch (e) {
                result = {};
            }
            this.wrapper.classList.remove('loading');
            if (!result.success) {
                this.showError((result.data || {}).message);
                return;
            }
            this.wrapper.querySelector('[data-id="cost_savings"]').classList.remove('hidden');
            let data = result.data;
            this.costResultMonth.innerHTML = data.cost_savings.month;
            this.costResultYear.innerHTML = data.cost_savings.year;
            this.amountResultMonth.innerHTML = data.amount_savings.month;
            this.amountResultYear.innerHTML = data.amount_savings.year;
            if (data.cost_savings.month == 0) {
                this.wrapper.querySelector('[data-id="cost_savings"]').classList.add('hidden');
            }
            this.results.classList.add('opened');
            scrollTo(this.best);
        }, data, '', 'POST', false, true);
    }
}

(new TallowCalculator(document.querySelector('.tallow-calculator'))).init();
